var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicatorView",style:({
    border: '5px solid ' + _vm.element.edgeColor,
    borderRadius: '6px'
  })},[_c('h1',{style:({ color: _vm.element.color, margin: '0', fontSize: '2rem' })},[_vm._v(" "+_vm._s(_vm.element.value)+" ")]),_c('h4',{style:({ color: _vm.element.textColor, margin: '0', fontSize: '1.5rem' })},[_vm._v(" "+_vm._s(_vm.element.indicatorOrTagName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }